import React from 'react';
import { Button, ButtonGroup } from "react-bootstrap";
import device from '../../../../device.config';

const Row = ({ feed, partners, onRemove, onUpdate, showWhitelist, handleFormSubmit}) => {
    const switchPause = () => handleFormSubmit({ ...feed, update: true, paused: feed.paused ? 0 : 1 })

    return (<tr>
        <td style={{ textAlign: 'left' }}>{feed.id}</td>
        <td>{feed.name}</td>
        <td>{feed.type}</td>
        <td>{feed.creative}</td>
        <td>{feed.auth}</td>
        <td>{feed.factor}</td>
        <td>{partners[feed.partnerId]}</td>
        <td>{feed.zone}</td>
        <td>{device[feed.device]}</td>
        <td>{feed.roi}</td>
        <td>{feed.cpm}</td>
        <td><Button onClick={() => showWhitelist(feed.whitelist)} bsStyle={feed.whitelist ? 'success' : 'info' }>Whitelist</Button></td>
        <td>
            <ButtonGroup >
                <Button bsStyle="info" onClick={() => onUpdate(feed)}>Update</Button>
                <Button bsStyle={ feed.paused ? "success" : "danger" } onClick={switchPause}>{feed.paused ? "Start" : "Pause"}</Button>
                <Button bsStyle="danger" onClick={() => onRemove(feed.id)}>Remove</Button>
            </ButtonGroup>
        </td>
    </tr>);
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/AdkFeeds/components/Table/components/Row/index.js